import { StudioError } from "~/errors";

export class InferenceError extends StudioError {}
